import { Stack } from "expo-router";
import TrafficFlowConfigureScreen from "@src/features/traffic-flow/screens/TrafficFlowConfigureScreen.web";

export default function TenantTrafficFlowConfigureScreen() {
  return (
    <>
      <Stack.Screen options={{ headerShown: false }} />
      <TrafficFlowConfigureScreen />
    </>
  );
}
